import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Uri from "jsuri";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
} from "./../../Utils/Utils.js";

const metric = (cell, row, rowIndex, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class Top5Posts extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const isVideoWidget = title.includes("Videos");
    const columnLabel = isVideoWidget ? "Views" : "Impressions";
    const defaultSortType = isVideoWidget ? "views" : "engagements";

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
      },
      {
        dataField: "views",
        text: columnLabel,
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagements",
        text: "Engagements",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: defaultSortType,
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportSelection: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return <div>{this.renderTable(data.data)}</div>;
  }
}

export default Top5Posts;
